
import { FreeBlock } from "@/utils/documents/free-block";
import Vue from "vue";
import AppFreeBlockEdit from "./FreeBlockEdit.vue";
import { ReminderLayout } from "@/utils/reminder-layouts/reminder-layout";

export default Vue.extend({
	data(){
		return {
			toEditBlock: null as null | FreeBlock
		};
	},
	props: {
		blocks: {
			type: Array as ()=>FreeBlock[],
			required: true
		},
		layout: {
			type: Object as ()=>ReminderLayout,
			required: true
		},
		initToEditFreeBlock: {
			type: Object as ()=>FreeBlock
		}
	},
	computed: {
		toEditBlockIndex():number{
			if (!this.toEditBlock) {
				return -1;
			}
			return this.blocks.indexOf(this.toEditBlock);
		}
	},
	methods: {
		addFreeBlock(){
			this.blocks.push(new FreeBlock());
		},
		editBlock(block:FreeBlock){
			this.toEditBlock = block;
		},
		async removeBlock(i:number){
			let confirm = await this.$confirmBuilder().setWarningTitle().setClass("warning").setMessage(this.$ct("are-you-sure-you-want-to-remove-this-free-block")).show();
			if (!confirm){
				return;
			}
			if (this.blocks[i] == this.toEditBlock) {
				this.toEditBlock = null;
			}
			this.blocks.splice(i,1);
		}
	},
	mounted(){
		this.toEditBlock = this.initToEditFreeBlock;
	},
	components: {
		AppFreeBlockEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
